import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { entitiesReducer, queriesReducer } from 'redux-query';
import { routeReducer } from 'react-router-redux';
import { browserHistory } from 'react-router';
import requery from '../requery/reducer';
import user from './user';
import smBrowser from '../components/sm/pages/reducer';
import ui from './ui';
import packs from '../packs/reducer';
import makerToolPage from '../grid-maker-tool-page/reducer';
import ppi from '../ppi/reducer';
import commonI18Dashboard from '../common-i18-dashboard-page/reducer';
//ToDo: topScorersReducer create a separate store !

import pagination from './pagination';
import { oddsSelection } from 'dash-front/odds/actions';

import editor from 'dash-front/editor/reducer';
import widgetPicker from 'dash-front/widget-picker/reducer';
import portfolio from 'dash-front/portfolio/reducer';

const query = combineReducers({
    entities: entitiesReducer,
    queries: queriesReducer,
});

const routing = (state = { location: browserHistory.getCurrentLocation() }, action) => routeReducer(state, action);

//ToDo: topScorersReducer create a separate store !!
export default combineReducers({
    oddsSelection: oddsSelection.buildReducer('oddsSelection'),
    pagination,
    routing,
    query,
    requery,
    form,
    user,
    ui,
    smBrowser,
    packs,
    makerToolPage,
    ppi,
    commonI18Dashboard,
    editor,
    portfolio,
    widgetPicker,
});



/** WEBPACK FOOTER **
 ** ../src/dash/front/reducers/index.js
 **/